// SolidNavbar is now an alias for Navbar.
// All pages can import either name — they are the same component.
export { Navbar as SolidNavbar } from './Navbar';
export type { NavbarProps as SolidNavbarProps } from './Navbar';
